import React, { useEffect, useMemo } from "react";
import fondo from "./ismaael.jpeg";
import "./ComicPagina.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import MenuPrincipal from "./MenuPrincipal";

const popularesIniciales = [
  { id: "popular-kimetsu", nombre: "Kimetsu no Yaiba", imagen: "sera.webp" },
  { id: "popular-jujutsu", nombre: "Jujutsu Kaisen", imagen: "arc.jpeg" },
  { id: "popular-chainsaw", nombre: "Chainsaw Man", imagen: "sera.webp" },
  { id: "popular-attack", nombre: "Attack on Titan", imagen: "arc.jpeg" },
  { id: "popular-blue-lock", nombre: "Blue Lock", imagen: "sera.webp" },
  { id: "popular-death-note", nombre: "Death Note", imagen: "arc.jpeg" },
];

const ComicPagina = ({ comics = [] }) => {
const navigate = useNavigate();
const { num } = useParams();

const paginaActual = Number(num) || 1;
const comicsPorPagina = 24;


  
const totalPaginas = Math.ceil(comics.length / comicsPorPagina);
const inicio = (paginaActual - 1) * comicsPorPagina;
const comicsVisibles = comics.slice(inicio,inicio+comicsPorPagina);

  const srcImg = (img) => img?.startsWith("http") ? img : `/${img}`;
  const comicsPopulares = useMemo(() => {
    const publicados = comics
      .filter((comic) => comic.esPopular)
      .sort(
        (a, b) =>
          new Date(b.popularAt || b.fecha || 0) -
          new Date(a.popularAt || a.fecha || 0)
      );

    return [...publicados, ...popularesIniciales].slice(0, 6);
  }, [comics]);

  useEffect(() => {
    const cards = Array.from(document.querySelectorAll(".comic-card"));
    const listeners = cards.map((card) => {
      const handleMove = (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty("--x", `${event.clientX - rect.left}px`);
        card.style.setProperty("--y", `${event.clientY - rect.top}px`);
      };

      card.addEventListener("mousemove", handleMove);
      return { card, handleMove };
    });

    return () => {
      listeners.forEach(({ card, handleMove }) => {
        card.removeEventListener("mousemove", handleMove);
      });
    };
  }, [comicsPopulares]);

 return (
  <div>
    <header
      className="header-fondo"
      style={{
        background: `url(${fondo}) no-repeat center center/cover`,
        padding: "40px 0",
        textAlign: "center",
        color: "#fff",
      }}
    >
      <h1
        className="titulo"
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
      >
        TMOXNight
      </h1>

      <MenuPrincipal />
    </header>

    <main>

      <section className="comics-populares ultra">
        <h2>⚡ Cómics Populares</h2>

        <div className="populares-ultra">
          {comicsPopulares.map((comic, index) => (
            <div className="comic-card" key={comic.id}>
              <div className="glow"></div>

              <img
                src={srcImg(comic.imagen)}
                alt={comic.nombre}
                loading={index === 0 ? "eager" : "lazy"}
                decoding="async"
                fetchPriority={index === 0 ? "high" : "auto"}
              />

              <div className="info">
                <h3>{comic.nombre}</h3>

                {comic.enlace ? (
                  <Link to={comic.enlace} className="comic-popular-btn">
                    Leer Ahora
                  </Link>
                ) : (
                  <button type="button">Leer Ahora</button>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="catalogo">
        <h2>Cómics Nuevos</h2>

        <div className="grid">
          {comicsVisibles.map((comic) => (
            <div className="comic-new-card" key={comic.id}>
              <img
                src={srcImg(comic.imagen)}
                alt={comic.nombre}
                loading="lazy"
                decoding="async"
              />

              <div className="info">
                <h3>{comic.nombre}</h3>

                <Link
                  to={comic.enlace}
                  className="comic-new-btn"
                >
                  Leer Comic
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div id="pagination" style={{ marginTop: 20, textAlign: "center" }}>
          {Array.from({ length: totalPaginas }).map((_, i) => (
            <button
              key={i}
              className={`page-number ${
                i + 1 === paginaActual ? "active" : ""
              }`}
onClick={() =>
  navigate(i === 0 ? "/" : `/page/${i + 1}`)
}            >
              {i + 1}
            </button>
          ))}

          {paginaActual < totalPaginas && (
            <button
              id="next-page"
onClick={() =>
  navigate(`/page/${paginaActual + 1}`)
}            >
              Siguiente
            </button>
          )}
        </div>
      </section>

    </main>

    <footer>
      <p>
        &copy; 2024 TMOXNight. Todos los derechos reservados.
      </p>
    </footer>
  </div>
);
};

export default ComicPagina;